// extracted by mini-css-extract-plugin
export default {"container":"CA-z"};